import React from "react";
import ReactDOM from "react-dom";
import { Alert } from "@mui/material";
import { Link } from "react-router-dom";
import { RouteHelpers, Routes } from "../../../root/routes";
import { usePrimaryOrganization } from "../../../hooks";

const MailboxDisconnectedAlert = () => {
  const [org] = usePrimaryOrganization();
  const usesPostmarkDomainSettings =
    org?.sendMethod === "POSTMARK" || org?.postmarkMailboxMode === "SHARED";
  const settingsLink =
    usesPostmarkDomainSettings && org
      ? RouteHelpers.organization.domain(org.id)
      : Routes.privacyCenter.privacyEmails;
  const settingsLabel = usesPostmarkDomainSettings ? "domain settings" : "privacy inbox settings";

  return (
    <Alert
      severity="error"
      sx={{
        backgroundColor: "var(--color-red-200)",
        color: "var(--color-red-700)",
      }}
    >
      Oh no! It looks like your privacy email has been disconnected. Please visit your{" "}
      <Link to={settingsLink}>{settingsLabel}</Link> to reconnect it.
    </Alert>
  );
};

export const MailboxDisconnectedBanner = () => {
  const mount = document.getElementById("top-banner");
  return ReactDOM.createPortal(<MailboxDisconnectedAlert />, mount);
};
